// extracted by mini-css-extract-plugin
export default {"landscape-left-right":"ccXLMbc69hoUikM81AID","type-default":"SY7Q6krL98RV5Pq4xx7Q","type-small":"MmcEoYfeUfkeGw6LRBt3","common_bganimation":"NsCJDwVIsmdwJ8JyaQqv"};